/**
 * Contact Form Handler
 * Handles form submission with sending/success states
 */
(function() {
  const SELECTORS = {
    form: '.contact-form__wrapper form',
    submitBtn: '.contact-form__submit',
    formBody: '.contact-form',
    audienceTab: '[data-contact-audience-tab]',
    audiencePanel: '[data-contact-audience-panel]'
  };

  var LEAVE_DURATION = 180;

  function setAudience(audience) {
    document.querySelectorAll(SELECTORS.audiencePanel).forEach(function(panel) {
      var isActive = panel.dataset.contactAudiencePanel === audience;

      panel.hidden = !isActive;
      panel.querySelectorAll('input, select, textarea').forEach(function(field) {
        field.disabled = !isActive;
      });
    });
  }

  function initAudienceSwitch() {
    var formBody = document.querySelector(SELECTORS.formBody);
    var tabs = document.querySelectorAll(SELECTORS.audienceTab);

    if (!formBody || !tabs.length) return;

    var timer;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        if (tab.getAttribute('aria-pressed') === 'true') return;

        var audience = tab.dataset.contactAudienceTab;

        tabs.forEach(function(otherTab) {
          otherTab.setAttribute('aria-pressed', String(otherTab === tab));
        });

        clearTimeout(timer);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          setAudience(audience);
          return;
        }

        formBody.classList.add('contact-form--leaving');

        timer = setTimeout(function() {
          setAudience(audience);

          // Jump below the resting position without a transition, then animate back up
          formBody.classList.remove('contact-form--leaving');
          formBody.classList.add('contact-form--entering');
          void formBody.offsetHeight;
          formBody.classList.remove('contact-form--entering');
        }, LEAVE_DURATION);
      });
    });
  }

  function initContactForm() {
    var form = document.querySelector(SELECTORS.form);
    var submitBtn = document.querySelector(SELECTORS.submitBtn);

    if (!form || !submitBtn) return;

    var originalText = submitBtn.textContent;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Stage 1: Sending
      submitBtn.classList.add('contact-form__submit--sending');
      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;

      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(function(response) {
        // Stage 2: Success
        submitBtn.classList.remove('contact-form__submit--sending');
        submitBtn.classList.add('contact-form__submit--success');
        submitBtn.textContent = 'Message Sent!';

        form.reset();

        setTimeout(function() {
          submitBtn.classList.remove('contact-form__submit--success');
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 3000);
      })
      .catch(function(error) {
        submitBtn.classList.remove('contact-form__submit--sending');
        submitBtn.textContent = 'Error - Try Again';
        submitBtn.disabled = false;

        setTimeout(function() {
          submitBtn.textContent = originalText;
        }, 3000);
      });
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initContactForm();
      initAudienceSwitch();
    });
  } else {
    initContactForm();
    initAudienceSwitch();
  }
})();
